export const PATIENTS = [{
    id: 1,
    name: 'New Patient',
    value: "new_patient"
}, {
    id: 2,
    name: "Returning Patient",
    value: "returning_patient"
}];


export function loadPatients() {
    let list = document.querySelector('.patients__container .patients__list');
    let partientList = ``;
    for (const i of PATIENTS) {
        partientList = partientList.concat(`
        <button class="patient" data-patient-id="${i.id}">
            <span class="patient__name">${i.name}</span>
            <span class="patient__checkbox" data-patient-id="${i.id}">
                <i class="patient__icon-check ri-check-line"></i>
            </span>
        </button>
        `);
    }
    list.innerHTML = partientList;
}
